<template>
    <div class="common_table custom_scroll">
        <div class="common_table custom_scroll _700">
            <table class="areaTable">
                <colgroup>
                    <col style="max-width: 350px" />
                    <col style="max-width: 350px" />
                </colgroup>
                <thead class="left">
                    <tr>
                        <th>날짜</th>
                        <th>접속자</th>
                    </tr>
                </thead>
                <tbody>
                    <tr style="background-color: #f5f5f5">
                        <td>총 접속자</td>
                        <td>{{ CommonUtils.numberFormat(state.sum) }}</td>
                    </tr>

                    <template v-if="state.list.length > 0">
                        <tr v-for="(item, idx) in state.list" :key="idx">
                            <td>{{ CommonUtils.dateFormatYYMMDD(item.targetCol, ".") }}</td>
                            <td>{{ CommonUtils.numberFormat(item.cnt) }}</td>
                        </tr>
                    </template>
                </tbody>
            </table>
            <PageBtn
                v-if="state.list.length !== 0"
                :currentPage="state.page"
                :totalLength="state.totalLength"
                :perPage="state.size"
                @onPaging="handlePageChange"
            ></PageBtn>
        </div>

        <div class="graph_wrap">
            <Chart
                v-if="visitHistoryState.isDraw"
                :titlePadding="visitHistoryState.titlePadding"
                :data="visitHistoryState.data"
                :legendPosition="visitHistoryState.legendPosition"
                :width="visitHistoryState.chartWidth"
                :height="visitHistoryState.chartHeight"
                :title="visitHistoryState.title"
                :subTitle="visitHistoryState.subTitle"
            ></Chart>
        </div>
    </div>
</template>

<script lang="ts" config>
    import { globalStore, reactive, watch, apiService, onMounted, types, PageBtn, CommonUtils, chart } from "@/BaseComponent";

    export default {
        props: {
            startDate: { type: String, required: true },
            endDate: { type: String, required: true },
        },
        components: { PageBtn, Chart: chart },
        setup(props: any) {
            const global = globalStore();
            const state = reactive({
                startDate: "" as string,
                endDate: "" as string,
                list: [] as Array<types.GroupResult>,
                page: 1 as number,
                size: 5 as number,
                totalPage: 1 as number,
                totalLength: 0 as number,

                sum: 0 as number,
            });

            const visitHistoryState = reactive({
                list: [] as Array<types.GroupResult>,
                startDate: "" as string,
                endDate: "" as string,

                isDraw: false as boolean,

                title: "접속자 시계열 그래프", // O
                subTitle: "", // O
                defaultType: "" as string, // line, bar, pie, donut, candle 차트의 초기 값입니다.
                titlePadding: [10, 0, 100, 10] as Array<number>, //[up,right,down,left]
                data: {
                    data: [
                        [276, 132, 101, 134, 90],
                        [290, 200, 150, 170, 120],
                        [310, 210, 160, 180, 130],
                        [320, 220, 170, 190, 140],
                        [200, 230, 180, 200, 150],
                    ] as any,
                    legend: ["Email", "Union Ads", "Video Ads", "Direct", "Search Engine"],
                    category: ["Mon", "Tue", "Wed", "Thu", "Fri"],
                },
                legendPosition: "left" as string, // 'left' bottom
                chartWidth: "100%" as string,
                chartHeight: "100%" as string,
            });

            onMounted(() => {
                state.startDate = props.startDate;
                state.endDate = props.endDate;
                getList();
                global.chartSet("line");
                getVisitHistory();
            });

            watch(props, () => {
                state.startDate = props.startDate;
                state.endDate = props.endDate;
                getList();
                global.chartSet("line");
                getVisitHistory();
            });

            const getList = async () => {
                const param: types.ReqParamForAdmin = {
                    page: state.page,
                    size: state.size,
                    searchType: "",
                    searchText: "",
                    startDate: state.startDate,
                    endDate: state.endDate,
                };
                const res = await apiService.statistics.user(param);
                if (res.returnCode === 0) {
                    state.list = res.list.data;
                    state.totalPage = res.list.totalPages;
                    state.totalLength = res.list.recordsTotal;
                    state.sum = res.sum;
                } else {
                    state.list = [];
                    state.totalPage = 0;
                    state.totalLength = 0;
                    state.sum = 0;
                }
            };

            const handlePageChange = (page: number) => {
                state.page = page;
                getList();
            };

            const getVisitHistory = async () => {
                visitHistoryState.isDraw = false;
                const param: types.ReqParamForDashboard = {
                    startDate: state.startDate,
                    endDate: state.endDate,
                };

                const res = await apiService.dashboard.visitHistory(param);

                if (res.returnCode === 0) {
                    visitHistoryState.list = res.list;

                    const category = visitHistoryState.list.map((item) => CommonUtils.dateFormatYYMMDD(item.targetCol));
                    const data = visitHistoryState.list.map((item) => item.cnt);

                    visitHistoryState.data.data = [data];
                    visitHistoryState.data.legend = ["date"];
                    visitHistoryState.data.category = category;

                    visitHistoryState.isDraw = true;
                } else {
                    console.error(res.description);
                }
            };

            return { state, handlePageChange, CommonUtils, visitHistoryState, getVisitHistory };
        },
    };
</script>

<style scoped>
    .graph_wrap {
        height: 250px;
    }

    table.areaTable tr {
        height: auto;
    }

    table.areaTable tr td {
        padding: 3px 10px;
    }

    .common_table {
        overflow-y: auto !important;
    }
</style>
